export default function ScenariosSection() {
  const scenarios = [
    {
      title: '云游戏',
      description: '超低延迟云游戏体验',
      details: [
        '毫秒级响应',
        '4K高清画质',
        '多端同步'
      ],
      icon: 'ri-gamepad-line',
      gradient: 'from-purple-500 to-pink-500'
    },
    {
      title: '电商直播',
      description: '高并发直播电商平台',
      details: [
        '海量并发支持',
        '实时互动体验',
        '智能推荐'
      ],
      icon: 'ri-live-line',
      gradient: 'from-blue-500 to-cyan-500'
    },
    {
      title: '企业办公',
      description: '云端协作办公解决方案',
      details: [
        '多人协作',
        '数据安全',
        '移动办公'
      ],
      icon: 'ri-building-line',
      gradient: 'from-green-500 to-blue-500'
    }
  ];

  const stats = [
    { value: '1000+', label: '企业客户' },
    { value: '99.9%', label: '服务可用性' },
    { value: '24/7', label: '技术支持' },
    { value: '50+', label: '行业解决方案' },
  ];

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">场景应用</h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
            覆盖多个行业场景，为不同业务需求提供专业的ARM云解决方案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {scenarios.map((scenario, index) => (
            <div key={index} className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:scale-[1.02]">
                {/* Background */}
                <div className="relative h-72 sm:h-80">
                  <div className={`absolute inset-0 bg-gradient-to-br ${scenario.gradient}`}></div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-20">
                    <i className={`${scenario.icon} text-9xl text-white`}></i>
                  </div>
                </div>
                
                {/* Content */}
                <div className="absolute inset-0 flex flex-col justify-end p-5 sm:p-6 text-white">
                  <div className="w-12 h-12 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center mb-3">
                    <i className={`${scenario.icon} text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold mb-2">{scenario.title}</h3>
                  <p className="text-white/90 mb-3 sm:mb-4 text-sm sm:text-base">{scenario.description}</p>
                  
                  <ul className="space-y-1 sm:space-y-1.5 mb-3 sm:mb-4">
                    {scenario.details.map((detail, idx) => (
                      <li key={idx} className="flex items-center text-sm">
                        <i className="ri-check-line mr-2"></i>
                        {detail}
                      </li>
                    ))}
                  </ul>
                  
                  <div className="flex items-center text-sm font-medium group-hover:translate-x-2 transition-transform duration-300">
                    了解更多 <i className="ri-arrow-right-line ml-2"></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Statistics */}
        <div className="mt-10 sm:mt-12 lg:mt-16 bg-white rounded-2xl p-6 sm:p-8 shadow-lg">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8 text-center">
            {stats.map((stat, index) => (
              <div key={index} className="p-2">
                <div className="text-2xl sm:text-3xl font-bold text-blue-600 mb-1 sm:mb-2">{stat.value}</div>
                <div className="text-sm sm:text-base text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
